import { NgModule } from '@angular/core';
import { CommonModule as NgCommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import {
	MatIconRegistry,
	MatIconModule,
	MatMenuModule,
	MatButtonModule,
	MatGridListModule,
	MatCardModule,
	MatListModule,
	MatTabsModule,
	MatToolbarModule,
	MatSelectModule,
	MatInputModule,
	MatCheckboxModule,
	MatTooltipModule,
} from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';
import { CovalentLoadingModule, CovalentChipsModule, CovalentDataTableModule } from '@covalent/core';

import { DialogModule } from './dialog';
import { ChipsModule } from './chips';
import { MessageService } from 'common/message.service';

const modules = [
	NgCommonModule,
	HttpClientModule,
	FormsModule,
	FlexLayoutModule,
	MatIconModule,
	MatMenuModule,
	MatButtonModule,
	MatGridListModule,
	MatCardModule,
	MatListModule,
	MatTabsModule,
	MatToolbarModule,
	MatSelectModule,
	MatInputModule,
	MatCheckboxModule,
	CovalentLoadingModule,
	CovalentChipsModule,
	CovalentDataTableModule,
	DialogModule,
	ChipsModule,
	MatTooltipModule,
];

@NgModule({
	imports: modules,
	exports: modules,
	providers: [MessageService],
})
export class CommonModule {
	constructor(private iconRegistry: MatIconRegistry, private domSanitizer: DomSanitizer) {
		this.addSvgIconInNamespace('logos:app', require('./assets/logos/app-logo.svg'));
		this.addSvgIconInNamespace('logos:tricentis', require('./assets/logos/tricentis-logo.svg'));
		this.addSvgIconInNamespace('logos:manager', require('./assets/logos/manager-logo.svg'));
		this.addSvgIconInNamespace('logos:sessions', require('./assets/logos/sessions-logo.svg'));
		this.addSvgIconInNamespace('logos:insights', require('./assets/logos/insights-logo.svg'));
		this.addSvgIconInNamespace('logos:parameters', require('./assets/logos/parameters-logo.svg'));
		this.addSvgIconInNamespace('logos:launch', require('./assets/logos/launch-logo.svg'));
		this.addSvgIconInNamespace('logos:pulse', require('./assets/logos/pulse-logo.svg'));
		this.addSvgIconInNamespace('logos:analytics', require('./assets/logos/analytics-logo.svg'));
		this.addSvgIconInNamespace('logos:testproject', require('./assets/logos/testproject.svg'));
	}

	private addSvgIconInNamespace(icon: string, url: string) {
		let [namespace, iconName] = icon.split(':');
		this.iconRegistry.addSvgIconInNamespace(
			namespace,
			iconName,
			this.domSanitizer.bypassSecurityTrustResourceUrl(url)
		);
	}
}
